import styled from 'styled-components';

export const TaskAttachmentsList = styled.div`
  max-height: 210px;
  overflow: auto;
  margin: 1rem 0 0;
  overflow: scroll;
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  flex-direction: column;
  gap: 2rem;
  row-gap: 1.5rem;
`;
